module.exports = __webpack_public_path__ + "static/bg-stationary-5fab02376411418b72263d36d5d38b81.png";